import MetaDataStrip from '@/components/common/MetaDataStrip';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import React, { useContext } from 'react';

const MetaDetails = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { meta } = courseDetails || {};

  return <MetaDataStrip meta={meta} className="!bg-[#F8F8F8] shadow-light" />;
};

export default MetaDetails;
